import { telemetryClient, createAxiosInstance } from '../axiosClient'
import { IDevice } from '@/types/telemetry'
import { TELEMETRY_API, TELEMETRY_API_KEY } from '@/constant/constants'
import {
  IAsset,
  IUpdateAsset,
  IPayloadGetTagLatestValue,
} from '@/types/telemetry'
import queryStringify from '@/ultils/queryStringify'

const headers = {
  'X-API-Key': 'api-read-key-3456789012',
}

const WRITE_API_KEY = 'api-write-key-2345678901'
const headersWrite = {
  'X-API-Key': 'api-write-key-2345678901',
}

const ROOT_API = 'api/Asset'
const ROOT_API_TAG = 'api/Tag'

export const telemetryApi = {
  getAllAsset(): Promise<{ data: IAsset[] }> {
    const url = `${ROOT_API}/list`
    const PageSize = 0 ///Asset/list?PageSize=10000&PageIndex=1
    return telemetryClient
      .get<{ data: IAsset[] }>(url, {
        params: { PageSize },
        headers,
      })
      .then((res) => res.data)
  },

  getAllDeviceByEntity(entityId: number): Promise<{ data: IDevice[] }> {
    return createAxiosInstance({ baseURL: TELEMETRY_API, apiKey: TELEMETRY_API_KEY })
      .get<{ data: IDevice[] }>(`/api/Asset/list`, {
        params: { PageSize: 0, EntityId: entityId },
      })
      .then((res: any) => res.data)
  },

  getAssetDetail(id: number): Promise<IAsset> {
    const url = `${ROOT_API}/${id}`
    return telemetryClient.get<IAsset>(url, { headers }).then((res) => res.data)
  },

  getAllDataKeys(assetId: number): Promise<{ data: string[] }> {
    const url = `${ROOT_API}/keys/${assetId}`
    return telemetryClient
      .get<string[]>(url, {
        headers,
      })
      .then((res) => res)
  },
  getTagByAssetId(AssetId: number, payload: Record<string, any>) {
    let url = `${ROOT_API_TAG}/list`
    url += queryStringify({
      AssetId,
      ...payload,
    })
    return telemetryClient
      .get<any>(url, {
        headers,
      })
      .then((res) => res)
  },

  getTagLatestValues(items: IPayloadGetTagLatestValue[]) {
    let url = `${ROOT_API_TAG}/values`
    return telemetryClient
      .post<any>(url, { items }, { headers })
      .then((res) => res)
  },

  updateAsset(id: number, payload: IUpdateAsset): Promise<IAsset> {
    const url = `${ROOT_API}/${id}`
    return telemetryClient
      .put<IAsset>(url, payload, { headers: headersWrite })
      .then((res) => res.data)
  },
}

export default telemetryApi
